import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipDirective } from '@sb/tooltip';
import { BadgeIconComponent } from '@sb/ui/badge-icon';
import { IconButtonComponent } from '@sb/ui/button';
import { IconComponent } from '@sb/ui/icon';
import { StatusButtonComponent, StatusIconComponent } from '@sb/ui/status';
import { type StatusIconType } from '@sb/ui/status/status-mapping.helper';

import { AbsenceRequestDirective } from '../../../../../+modals/employee/absence-request/absence-request.directive';
import { AbsenceOptionUnit } from '../../../../../enums';
import { DecimalToDurationFormatPipe } from '../../../../../pipes/decimal-to-duration-format.pipe';
import { LocaleDatePipe } from '../../../../../pipes/locale-date.pipe';
import { AbsenceStatus, EnhancedAbsenceModel } from '../../../../../reducers/orm/absence/absence.model';
import { AbsenceService } from '../../../../../reducers/orm/absence/absence.service';
import { AbsenceBadgeIconDirective } from '../../../../../shared/absence/absence-badge-icon.directive';

const ABSENCE_STATUS_PER_ICON_TYPE: Record<StatusIconType, AbsenceStatus> = {
  Approved: AbsenceStatus.APPROVED,
  Declined: AbsenceStatus.DECLINED,
  Pending: AbsenceStatus.PENDING,
};

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'absence-row',
  imports: [
    RouterModule,
    TooltipDirective,
    TranslatePipe,
    AbsenceBadgeIconDirective,
    AbsenceRequestDirective,
    LocaleDatePipe,
    DecimalToDurationFormatPipe,
    BadgeIconComponent,
    IconComponent,
    IconButtonComponent,
    StatusButtonComponent,
    StatusIconComponent,
  ],
  templateUrl: './absence-row.component.html',
})
export class AbsenceRowComponent {
  private absenceService = inject(AbsenceService);

  @Input()
  absence: EnhancedAbsenceModel;
  @Input()
  isOwnAbsence: boolean;

  AbsenceOptionUnit = AbsenceOptionUnit;

  changeStatus(absentee: EnhancedAbsenceModel, status: StatusIconType) {
    const updateData = {
      id: absentee.id,
      status: ABSENCE_STATUS_PER_ICON_TYPE[status],
    };

    void this.absenceService.save(updateData).subscribe();
  }
}
